import axios from "axios";

const ALL_ASSESSMENTS_CONTEXT_KEY = "@P3M3:allAssessmentsContext";
export const ALL_ASSESSMENTS_CONTEXT_HEADER = "X-All-Assessments-Context";

export function enableAllAssessmentsContext(): void {
  sessionStorage.setItem(ALL_ASSESSMENTS_CONTEXT_KEY, "true");
  axios.defaults.headers.common[ALL_ASSESSMENTS_CONTEXT_HEADER] = "true";
}

export function disableAllAssessmentsContext(): void {
  sessionStorage.removeItem(ALL_ASSESSMENTS_CONTEXT_KEY);
  delete axios.defaults.headers.common[ALL_ASSESSMENTS_CONTEXT_HEADER];
}

export function initializeAllAssessmentsContextHeader(): void {
  if (sessionStorage.getItem(ALL_ASSESSMENTS_CONTEXT_KEY) === "true") {
    axios.defaults.headers.common[ALL_ASSESSMENTS_CONTEXT_HEADER] = "true";
  }
}
